import React from 'react';
import WorksCom from "../../Components/WorksCom";
import styled from "styled-components";
import Footer from "../../Components/Footer/Footer";
const Works = () => {
    return (
        <Div>
            <WorksCom/>
            <div className="footer">
                <Footer/>
            </div>
        </Div>
    );
};
const Div = styled.div`
  width: 100%;
  margin: auto;

  .footer {
    
    margin: auto;
    width: 100%;
    opacity: 0; 
    animation: showFooter 2s ease-in-out 3s forwards; 

  
  }

  @keyframes showFooter {
    to {
      opacity: 1; 
    }
  }



`
export default Works;